import { createLogger } from '@/core/helpers/logger.helper';
import type { SeedApi } from '@/core/network/api/seed/seed.api';
import type { GamResponse } from '@/core/network/http/httpClient.interface';
import { HttpError } from '@/core/network/http/httpError';
import type { SeedStatsDto } from './seed.interface';

const logger = createLogger('SeedRepository');

export class SeedRepository {
  private readonly httpAPI: SeedApi;

  constructor(httpAPI: SeedApi) {
    this.httpAPI = httpAPI;
  }

  async getStats(): Promise<GamResponse<SeedStatsDto> | null> {
    try {
      const response = await this.httpAPI.getStats();
      return response.data?.data ? { data: response.data.data } : null;
    } catch (e) {
      const httpError = e as HttpError;
      logger.error(`${httpError.error.code} => ${httpError.error.message}`);
      throw httpError.error;
    }
  }
}
